import { useState, useRef, useEffect } from 'react';
import styles from './Header.module.css';

interface HeaderProps {
  title: string;
  userDisplayName: string;
  onLogout: () => void;
}

export default function Header({ title, userDisplayName, onLogout }: HeaderProps) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown on outside click
  useEffect(() => {
    if (!open) return;
    function handleClick(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const initial = userDisplayName.charAt(0).toUpperCase() || '?';

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <img
          src="/logos/harmony-logo.jpg"
          alt="Harmony"
          className={styles.icon}
        />
        <span className={styles.title}>{title}</span>
      </div>

      <div className={styles.avatarWrapper} ref={dropdownRef}>
        <button
          className={styles.avatar}
          onClick={() => setOpen((prev) => !prev)}
          aria-label="User menu"
          type="button"
        >
          {initial}
        </button>

        {open && (
          <div className={styles.dropdown}>
            <button
              className={styles.dropdownItem}
              onClick={() => {
                setOpen(false);
                onLogout();
              }}
              type="button"
            >
              Sign out
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
